<section aria-label="Page Banner" class="usa-graphic-list usa-section art-landing-page-banner">
    <div class="grid-container">
        <div class="grid-row grid-gap">
            <div class="tablet: grid-col">
                <span *ngIf="header" id="art-banner-header" class="art-banner-title-color font-sans-lg margin-bottom-0">
                    {{header}}
                </span>
                <br />
                <h1 *ngIf="title" id="art-banner-title" class="text-white font-sans-xl margin-top-0 margin-bottom-0">
                    {{title}}
                </h1>
            </div>
        </div>
    </div>
 </section>
